import { styled } from "@linaria/react";
export const InputBox = /*#__PURE__*/styled('textarea')({
  name: "InputBox",
  class: "gdg-izpuzkl",
  propsAsIs: false
});
export const ShadowBox = /*#__PURE__*/styled('div')({
  name: "ShadowBox",
  class: "gdg-s69h75o",
  propsAsIs: false
});
export const GrowingEntryStyle = /*#__PURE__*/styled('div')({
  name: "GrowingEntryStyle",
  class: "gdg-g1y0xocz",
  propsAsIs: false
});

